<template>
  <div id="ArticleCitationsModal">
    <v-dialog
      ref="articleCitationsDialogRef"
      v-model="show"
      attach="#ArticleCitationsModal"
      max-width="800"
      @keydown.esc="onClose"
    >
      <template #activator="activator">
        <button
          v-if="citationsCount"
          tabindex="0"
          class="onLogin"
          aria-haspopup="false"
          aria-expanded="false"
          v-bind="activator.attrs"
          @click="getCitations"
          v-on="activator.on"
        >
          <span class="d-sr-only">View article</span>
          <div class="underline">Citations</div>
        </button>
        <div v-else>Citations</div>
      </template>

      <v-card v-if="citations" class="pa-4">
        <v-card-actions style="position: relative">
          <v-spacer />
          <v-btn
            ref="closeButton"
            color="warning"
            text
            aria-label="close modal"
            @click="onClose"
            >Close</v-btn
          >
        </v-card-actions>

        <v-card-text class="pb-0">
          <div class="py-2 pb-4">
            <a
              class="crossrefLogo pr-4 pb-4"
              :class="`crossrefLogo-${displayIs}`"
              href="https://www.crossref.org"
              target="_blank"
              rel="noopener"
            >
              <img src="~/static/images/Crossref.svg" alt="Crossref logo" />
            </a>

            <div class="citationHeading">
              <h3 id="article-citations-modal-title">
                This content has been cited by the following publications. This
                list is generated based on data provided by CrossRef.
              </h3>
            </div>
          </div>
          <v-row v-if="showDownloadButton" justify="center" class="pt-2 pb-6">
            <div
              :class="`downloadButtonContainer downloadButtonContainer-${displayIs}`"
            >
              <DownloadButton
                ref="downloadButton"
                button-text="Download full list"
                :file-name="fileName"
                :file-type="fileType"
                :file-source="fileSource"
              />
            </div>
          </v-row>

          <v-divider />

          <CitationDetails
            v-for="(citation, index) in citations"
            :key="index"
            class="pt-2 pb-4"
            :citation="citation"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { displayIs } from "~/components/utilities/displayBreakpoints";

import DownloadButton from "~/components/articles/components/DownloadButton.vue";
import CitationDetails from "~/components/articles/components/CitationDetails.vue";

export default {
  name: "ArticleCitationsModal",
  components: { DownloadButton, CitationDetails },
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    displayIs,
    fileName() {
      return `${this.article.title} citations.`;
    },
    fileSource() {
      const endpoint = this.$config.clientEndpoint;
      return `${endpoint}/download/cited-by/${this.article.id}`;
    },
    fileType() {
      return "csv";
    },
    citations() {
      return this.article.citations;
    },
    showDownloadButton() {
      return this.article.citationsTotal > 20;
    },
    citationsCount() {
      return this.article.citationsCount;
    },
  },

  methods: {
    onClose() {
      this.show = false;
    },
    async getCitations() {
      await this.$store.dispatch("getArticleCitations", {
        id: this.article.id,
      });
      this.setInitialFocus();
      this.setAriaLabelAttribute();
    },
    setInitialFocus() {
      this.$nextTick(() => {
        this.showDownloadButton
          ? this.$refs.downloadButton.$refs.downloadButton.$el.focus()
          : this.$refs.closeButton.$el.focus();
      });
    },
    setAriaLabelAttribute() {
      this.$nextTick(() => {
        const dialogRef =
          this?.$refs?.articleCitationsDialogRef?.$children[0]?.$el;

        if (dialogRef) {
          const titleByElementId = document.getElementById(
            "article-citations-modal-title"
          ).textContent;
          dialogRef.setAttribute("aria-label", titleByElementId);
        }
      });
    },
  },
};
</script>

<style scoped>
.downloadButtonContainer-DESKTOP {
  width: 350px;
}

.crossrefLogo {
  float: left;
  width: 100px;
  height: 100%;
  text-align: center;
}

.crossrefLogo img {
  max-width: 100px;
}

.crossrefLogo-MOBILE {
  width: 100%;
}

.citationHeading {
  width: 100%;
  height: 100%;
}
</style>
